import { render } from "./cpt-phone-number-option.vue?vue&type=template&id=13be6e41"
import script from "./cpt-phone-number-option.vue?vue&type=script&lang=js"
export * from "./cpt-phone-number-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__